import { Component, Input, OnInit } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OddsFormatterService } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { IBasePrice, PickOddsState, PriceType } from '../../../core/picks/pick-models';
import { OverAskMarketTypeChange } from '../../../model/over-ask/over-ask';
import { SingleSlipType } from '../../bet-generation/slip-type';
import { IBetslipOverAskPickChangesProps } from '../models/over-ask.model';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPickChangesBaseComponent implements OnInit {
    @Input() props: IBetslipOverAskPickChangesProps;
    @Input() oddsDisplayFormat: OddsDisplayFormat;

    oddsStateType = PickOddsState;
    isSingleBet: boolean;
    readonly messages: {
        closed: string;
        startingPrice: string;
    };

    constructor(
        private priceFormatter: OddsFormatterService,
        siteCore: Sitecore,
    ) {
        this.messages = {
            closed: siteCore.betslip.messages.ClosedPick,
            startingPrice: siteCore.betslip.messages.StartingPrice,
        };
    }

    ngOnInit(): void {
        this.isSingleBet = this.props.betState.type instanceof SingleSlipType;
    }

    formatPrice(price: IBasePrice | undefined): string {
        if (!price) {
            return '';
        }
        switch (price.type) {
            case PriceType.Fixed: {
                return this.priceFormatter.format(price.nativeOdds, { displayFormat: this.oddsDisplayFormat });
            }
            case PriceType.NoPrice: {
                return '';
            }
            case PriceType.StartingPrice: {
                return this.messages.startingPrice;
            }
        }
    }

    get singleBetStake(): number | null {
        if (!this.isSingleBet) {
            return null;
        }
        const singleBetStake = this.props.betState.initialStake;
        if (singleBetStake) {
            return singleBetStake.toNumber();
        }

        return null;
    }

    get singleBetOverridenStake(): number | null {
        const overridenStake = this.props.betState.counterOfferStake;
        if (overridenStake) {
            return overridenStake.toNumber();
        }

        return null;
    }

    get pickInitialPrice(): IBasePrice {
        return this.props.overAskPickState.initialPrice;
    }

    get pickOverridenPrice(): IBasePrice | undefined {
        return this.props.overAskPickState.counterOfferPrice;
    }

    get isInitialEachWay(): boolean {
        return this.props.overAskPickState.isInitialEachWay;
    }

    get hasEachWayChange(): boolean {
        return !!this.props.overAskPickState.counterOfferMarketType;
    }

    get isCounterOfferEachWay(): boolean {
        return this.props.overAskPickState.counterOfferMarketType === OverAskMarketTypeChange.EachWay;
    }
}
